module.exports = __webpack_public_path__ + "more.a533eba1.png";